<template>
  <div>
    <div class="filtros">

      <v-select
        :items="[
          {text:'Vigentes', value:'vigentes'},
          {text:'Vencidos', value:'vencidos'}
        ]"
        v-model="filtroFecha"
        label="Estado"
        dense
        outlined
        clearable
      ></v-select>

      <v-select
        :items="[
          {text:'Más recientes', value:'recientes'},
          {text:'Más antiguos', value:'antiguos'},
          {text:'Por vencer', value:'vencer'}
        ]"
        v-model="ordenarPor"
        label="Ordenar por"
        dense
        outlined
      ></v-select>
    </div>
    <div class="jobs-list">
      <div
        v-for="job in oportunidadesConEmpresa"
        :key="job.idrequerimiento"
        class="job-card"
      >
        <!-- Logo -->
        <div class="job-logo">
          <img
            :src="job.logo_empresa"
            :alt="job.empresa_contratista"
          />
        </div>

        <!-- Info -->
        <div class="job-info">
          <h3 class="job-title"><strong>{{ job.denominacion.slice(0,3) }}</strong> - {{ nombreRubro(job.rubro_tipo_servicio) }}</h3>
          <div class="job-detalle">
            {{ detallesTexto(job.detalles) }}
          </div>
          <p class="job-company">{{ job.empresa_contratista }}</p>

          <div class="job-meta">
            <!-- <span class="meta-item">
              📍 {{ job.ubicacion }}
            </span> -->
            <span class="meta-item">
              📅 Publicado el {{ job.fecha_solicitud.split('T')[0].split('-').reverse().join('/') }}
            </span>
          </div>
          <div class="job-meta">
            <span
              class="meta-item meta-fecha-fin"
              :class="{
                urgente: diasRestantes(job.fecha_fin) <= 7 && diasRestantes(job.fecha_fin) >= 0
              }"
            >
              ⏰ Fecha final {{ job.fecha_fin.split('T')[0].split('-').reverse().join('/') }}
              <strong v-if="diasRestantes(job.fecha_fin) >= 0" style="font-size: 16px;">
                ({{ diasRestantes(job.fecha_fin) }} días)
              </strong>
            </span>
          </div>
        </div>

        <div class="job-right">
          <span
            v-if="!job.ya_postulado"
            class="badge"
            :class="estadoVisual(job).toLowerCase()"
          >
            {{ estadoVisual(job) }}
          </span>
          <span
            v-else
            class="badge en_evaluación"
          >
            YA POSTULADO
          </span>
          <span
            v-if="
              job.postulaciones &&
              job.postulaciones.length > 0 &&
              job.postulaciones[0].estado &&
              job.postulaciones[0].estado.toUpperCase() !== 'REGISTRADO'
            "
            class="badge"
            :class="job.postulaciones[0].estado.toLowerCase()"
          >
            {{ job.postulaciones[0].estado }}
          </span>

          <div
            class="job-actions"
            v-if="!['CERRADO', 'EN_PROCESO'].includes(job.estado.toUpperCase()) && !job.ya_postulado && esVigente(job.fecha_fin)"
          >
          <!-- <div
            class="job-actions"
          > -->
            <v-btn
              small
              text
              class="btn-detalle"
              @click="verDetalle(job)"
            >
              <v-icon left>mdi-eye</v-icon>
              Ver detalle
            </v-btn>

            <!-- <v-btn
              small
              outlined
              class="btn-tdr"
            >
              <v-icon left>mdi-file-document-outline</v-icon>
              Descargar TDR
            </v-btn> -->

            <v-btn
              small
              class="btn-postular"
              @click="postular(job)"
            >
              <v-icon left>mdi-send</v-icon>
              Postular
            </v-btn>
          </div>
        </div>

      </div>
      <v-dialog v-model="dialogDetalle" max-width="850" persistent :retain-focus="false">
          <v-card class="modal-card-pro">
            <!-- HEADER -->
            <div class="modal-header-color">
              <div class="header-left">
                <v-icon color="white" size="28">mdi-clipboard-text</v-icon>

                <div>
                  <h3 class="modal-title-color">
                    {{ detalle.denominacion }}
                  </h3>
                  <span class="empresa-badge">
                    {{ detalle.empresa_contratista }}
                  </span>
                </div>
              </div>

              <v-btn
                icon
                class="btn-close-modal"
                @click.stop="dialogDetalle = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>

            <!-- BODY -->
            <v-card-text class="modal-body-pro">
              <!-- DETALLE -->
              <section class="section-pro">
                <h4 class="section-title-pro">Detalle del requerimiento</h4>
                <div
                  v-for="item in lista_detalles"
                  :key="item.iddetalles"
                  class="detalle-item-pro"
                >
                  <div class="cantidad-pro">
                    {{ item.cantidad }}
                  </div>

                  <div class="detalle-info-pro">
                    <p class="servicio-pro">{{ item.servicio }}</p>
                    <p class="detalle-pro">{{ item.detalle }}</p>
                  </div>
                </div>

                <p v-if="!lista_detalles.length" class="empty-pro">
                  No hay detalles registrados.
                </p>
              </section>

              <!-- INFO -->
              <section class="info-grid-pro">
                <div class="info-item-pro">
                  <label>Observaciones</label>
                  <p>{{ detalle.observaciones || '—' }}</p>
                </div>

                <div class="info-item-pro">
                  <label>Tiempo de contratación</label>
                  <p>{{ detalle.tiempo_contratacion }} días</p>
                </div>

                <div class="info-item-pro">
                  <label>Área usuaria</label>
                  <p>{{ detalle.id_areausuaria || '—' }}</p>
                </div>

                <div class="info-item-pro">
                  <label>Contacto</label>
                  <p>{{ detalle.empresa_contacto }}</p>
                </div>

                <div v-if="idarchivo_req != null" class="alerta-archivo">
                    <span class="icono-alerta">⚠️</span> <strong class="texto-negrita">Antes de postular:</strong>
                    Este requerimiento contiene información adicional en un archivo adjunto. <strong class="texto-negrita">Es obligatorio revisar el archivo completo antes de presentar su postulación,</strong> ya que contiene detalles y especificaciones que deben ser considerados.<br>

                    <div class="contenedor-boton-archivo">
                      <button @click="verArchivo(idarchivo_req)">
                         <span class="icono-clip">📎</span> Ver archivo
                      </button>
                    </div>
                </div>

                <!-- <div class="info-item-pro">
                  <label>Correo</label>
                  <p class="email-pro">{{ detalle.correo }}</p>
                </div> -->
              </section>
            </v-card-text>

            <!-- FOOTER -->
            <v-card-actions class="modal-footer-pro">
              <v-spacer />
              <v-btn class="btn-cerrar-pro" @click="dialogDetalle = false">
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Modal Confirmación -->
        <div v-if="showConfirmarPostulacion" class="modal-overlay-postular">
          <div class="modal-content-postular">
            <div class="modal-icon">
              <v-icon size="56" color="#f59e0b">mdi-alert-circle-outline</v-icon>
            </div>

            <h2 class="modal-title-postular">
              Confirmar postulación
            </h2>

            <p class="modal-text">
              ¿Estás seguro de postular al siguiente requerimiento?
            </p>

            <div class="requerimiento-box">
              {{ jobSeleccionado.denominacion }}
            </div>

            <div class="modal-actions-inline">
              <button
                class="btn-cancel"
                @click="showConfirmarPostulacion = false"
              >
                Cancelar
              </button>

              <button
                class="btn-accept"
                @click="confirmarPostulacion"
              >
                Sí, postular
              </button>
            </div>
          </div>
        </div>
        <!-- <div v-if="showConfirm" class="modal-overlay-postular">
          <div class="modal-content-postular">
            <div class="modal-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-check"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#22c55e"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>

            <h2 class="modal-title-postular">¡Postulación Confirmada!</h2>

            <p class="modal-text">
              Tu postulación al requerimiento
              <strong>{{job.denominacion}}</strong>
              ha sido enviada correctamente y se encuentra en evaluación.
            </p>

            <button class="btn-accept" @click="postular_dialog()">
              Aceptar
            </button>
          </div>
        </div> -->
        <div v-if="showConfirm" class="modal-overlay-postular">
          <div class="modal-content-postular">
            <div class="modal-icon">
              <v-icon size="56" color="#22c55e">mdi-check-circle-outline</v-icon>
            </div>

            <h2 class="modal-title-postular">
              ¡Postulación registrada!
            </h2>

            <p class="modal-text">
              Tu postulación al requerimiento
              <div v-if="jobSeleccionado" class="req-nombre">
                {{ jobSeleccionado.denominacion }}
              </div>
              fue registrada correctamente.
            </p>

            <div class="instrucciones-box">
              <p><strong>Siguientes pasos del proceso:</strong></p>

              <p>
                Tu postulación ha sido enviada correctamente. El
                <strong>contratista</strong> revisará la información registrada y,
                de ser necesario, se pondrá en contacto contigo a través de los
                datos proporcionados.
              </p>

              <p class="nota">
                Te recomendamos estar atento a tu correo electrónico y teléfono.
              </p>
            </div>

            <button class="btn-accept" @click="postular_dialog">
              Entendido
            </button>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  data() {
    return {
      //Ayuda
      oportunidades: [],
      empresa_item: [],
      categorias_servicios: [],
      detalleAbierto: null,
      dialogDetalle: false, // 👈 IMPORTANTE
      detalle: {} ,
      lista_detalles: [],
      empresaid: null,       // 👈 AQUÍ
      usuario: null,
      registro: true,
      errorMessages: "",
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      dialogcontratosempresas: false,
      pattern: '/[A-Z]/\\W',
      loading: false,
      showConfirm: false,
      showConfirmarPostulacion: false,
      jobSeleccionado: null,
      filtroFecha: null, // vigentes o vencidos
      ordenarPor: "recientes",
      idarchivo_req: null,
    };
  },
  created() {
    this.idusuario = localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.empresaid = localStorage.getItem('empresa')
    this.empresaid = this.empresaid ? Number(this.empresaid) : null
    this.listar();
    this.listarEmpresasContratistas();
    this.cargarCategorias();
  },

  computed: {
    // oportunidadesConEmpresa() {
    //   return this.oportunidades.map(job => {
    //     const empresa = this.empresa_item.find(
    //       e => e.id_empresa_contratista === job.id_empresa_contratista
    //     );

    //     return {
    //       ...job,
    //       empresa_contratista: empresa ? empresa.empresa_contratista : 'Sin empresa',
    //       logo_empresa: empresa ? empresa.logo_empresa : null
    //     };
    //   });
    // }
    oportunidadesConEmpresa() {
      const f = (d) => d ? new Date(d + 'T00:00:00') : null

      let lista = this.oportunidades.map(job => {

        const empresa = this.empresa_item.find(
          e => e.id_empresa_contratista === job.id_empresa_contratista
        )

        return {
          ...job,
          empresa_contratista: empresa ? empresa.empresa_contratista : 'Sin empresa',
          logo_empresa: empresa ? empresa.logo_empresa : null
        }

      })
      // console.log(lista);

      // FILTRO FECHA
      if (this.filtroFecha === 'vigentes') {
        lista = lista.filter(j => this.esVigente(j.fecha_fin))
      }

      if (this.filtroFecha === 'vencidos') {
        lista = lista.filter(j => !this.esVigente(j.fecha_fin))
      }

      // ORDENAMIENTO
      if (this.ordenarPor === 'recientes') {
        // lista.sort((a,b)=> new Date(b.fecha_inicio) - new Date(a.fecha_inicio))
        // lista.sort((a, b) => {

        //   const hoy = new Date()

        //   const aVigente = this.esVigente(a.fecha_fin)
        //   const bVigente = this.esVigente(b.fecha_fin)

        //   // 🟢 1. Vigentes primero
        //   if (aVigente && !bVigente) return -1
        //   if (!aVigente && bVigente) return 1

        //   // 🟡 2. Si ambos vigentes → el que vence primero arriba
        //   if (aVigente && bVigente) {
        //     return new Date(a.fecha_fin) - new Date(b.fecha_fin)
        //   }

        //   // 🔴 3. Si ambos vencidos → el más reciente arriba
        //   return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
        // })
        // 1. Separar por estado
        const abiertos = lista.filter(x => x.estado === 'ABIERTO' || x.estado === 'EN_PROCESO')
        const cerrados = lista.filter(x => x.estado === 'CERRADO')

        // ABIERTOS
        abiertos.sort((a, b) => {

          const aVigente = this.esVigente(a.fecha_fin)
          const bVigente = this.esVigente(b.fecha_fin)

          // 1. Vigentes primero
          if (aVigente && !bVigente) return -1
          if (!aVigente && bVigente) return 1

          // 2. Ambos vigentes → vence primero
          if (aVigente && bVigente) {

            const t1 = a.fecha_fin
              ? new Date(a.fecha_fin + 'T23:59:59').getTime()
              : Infinity

            const t2 = b.fecha_fin
              ? new Date(b.fecha_fin + 'T23:59:59').getTime()
              : Infinity

            return t1 - t2
          }

          // 3. Ambos vencidos → reciente primero
          const t1 = a.fecha_solicitud
            ? new Date(a.fecha_solicitud).getTime()
            : 0

          const t2 = b.fecha_solicitud
            ? new Date(b.fecha_solicitud).getTime()
            : 0

          return t2 - t1
        })

        // CERRADOS → reciente primero
        cerrados.sort((a, b) => {

          const t1 = a.fecha_solicitud
            ? new Date(a.fecha_solicitud).getTime()
            : 0

          const t2 = b.fecha_solicitud
            ? new Date(b.fecha_solicitud).getTime()
            : 0

          return t2 - t1
        })

        lista = [...abiertos, ...cerrados]
      }

      if (this.ordenarPor === 'antiguos') {
        lista.sort((a, b) => {
          const t1 = a.fecha_solicitud ? new Date(a.fecha_solicitud).getTime() : Infinity
          const t2 = b.fecha_solicitud ? new Date(b.fecha_solicitud).getTime() : Infinity
          return t1 - t2
        })
      }

      if (this.ordenarPor === 'vencer') {
        const abiertos = []
        const cerrados = []

        for (const item of lista) {
          if (item.estado?.toUpperCase() === 'ABIERTO' || x.estado === 'EN_PROCESO') {
            abiertos.push(item)
          } else {
            cerrados.push(item)
          }
        }

        // 🟡 abiertos → vence primero
        abiertos.sort((a, b) =>
          new Date(a.fecha_fin).getTime() - new Date(b.fecha_fin).getTime()
        )

        // 🔴 cerrados → también por fecha_fin (o cambia criterio si quieres)
        cerrados.sort((a, b) =>
          new Date(a.fecha_fin).getTime() - new Date(b.fecha_fin).getTime()
        )

        lista = [...abiertos, ...cerrados]
      }

      return lista

    }
  },
  methods: {
    listar() {
      let me = this;
      me.oportunidades=[];
      me.requerimientoalerta_items=[];
      const idusuario = encodeURIComponent(me.idusuario)
      axios
        .get(`api/Requerimientos/ListarOportunidades?idusuario=${idusuario}`)
        .then(function (response) {
          me.oportunidades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarEmpresasContratistas() {
      let me = this;
      me.empresa_item=[];
      axios
        .get("api/Contratistas/Listar")
        .then(function (response) {
          me.empresa_item = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    listarDetalle(detalle) {
      let me = this;
      me.lista_detalles = [];
      axios
        .get(
          "api/Detalles/GetDetallesByRequerimiento/?idrequerimiento=" +
            detalle.idrequerimiento
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj['detalles']) {
            res.push(obj['detalles'][i]);
          }
          me.lista_detalles = res;
          me.idarchivo_req = obj['idarchivo'];
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async verArchivo(idarchivo) {
        try {
            const response = await axios.get(
                `/api/Requerimientos/VerArchivo/${idarchivo}`,
                {
                    responseType: 'blob'
                }
            );
            const blob = new Blob([response.data], {
                type: response.headers['content-type']
            });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            // Liberar memoria después de un tiempo
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 10000);
        } catch (error) {
            console.error('Error al visualizar archivo:', error);
            alert('No se pudo abrir el archivo.');
        }
    },
    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.categorias_servicios = response.data;
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    nombreRubro (idRubro) {
      // console.log(this.categorias_servicios)
      const rubro = this.categorias_servicios.find(
        c => c.id === idRubro
      )
      return rubro ? rubro.nombrecategoria : '—'
    },
    verDetalle(job) {
      this.detalle = job;
      this.dialogDetalle = true;
      this.listarDetalle(this.detalle);
    },
    postular(job) {
      this.jobSeleccionado = job;
      this.showConfirmarPostulacion = true;
    },
    confirmarPostulacion() {
      const job = this.jobSeleccionado
      if (!job) return
      const idrequerimiento = job.idrequerimiento
      const empresaid = this.empresaid

      if (!empresaid) {
        console.error('Empresa no encontrada en storage')
        return
      }

      axios
        .post('/api/PostulacionEmpresas/Crear', {
          idrequerimiento: idrequerimiento,
          id_empresa: empresaid,
        })
        .then(() => {
          this.showConfirmarPostulacion = false
          this.showConfirm = true;
          // this.listar();
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    postular_dialog() {
       this.showConfirm = false;
       this.listar();
    },
    cerrarConfirmacion() {
      this.showConfirm = false
      this.jobSeleccionado = null
    },
    esVigente(fechaFin) {
      if (!fechaFin) return false

      // Quitar la parte de la hora si viene con T
      const soloFecha = fechaFin.split('T')[0]

      const [y, m, d] = soloFecha.split('-')
      const fin = new Date(y, m - 1, d)

      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)
      return fin >= hoy
    },
    estadoVisual(job) {
      // Si ya no es vigente por fecha → CERRADO
      if (!this.esVigente(job.fecha_fin)) {
        return 'VENCIDO'
      }

      // Caso normal
      return job.estado
    },
    diasRestantes(fechaFin) {
      if (!fechaFin) return null

      // fechaFin viene como "YYYY-MM-DD" o "YYYY-MM-DDTHH:mm:ss"
      const fin = new Date(fechaFin.split('T')[0] + 'T00:00:00')
      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)

      const diff = fin - hoy
      return Math.ceil(diff / (1000 * 60 * 60 * 24))
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    }
  }
};

</script>
<style scoped>
.jobs-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.job-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  padding: 14px 18px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.job-logo {
  width: 70px;
  height: 70px;
  border-radius: 50%;        /* Círculo */
  background: #fff;
  border: 1px solid #e5e5e5;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  transition: all .25s ease;
}

/*.job-logo {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
}*/

.job-logo:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 14px rgba(0,0,0,.15);
}

.job-logo img {
  max-width: 95%;
  max-height: 95%;
  object-fit: contain;
}

.job-info {
  flex: 1;
  margin-left: 14px;
}

.job-title {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.job-company {
  font-size: 13px;
  font-weight: 600;
  color: #f97316;
  margin: 2px 0 6px;
}

.job-meta {
  display: flex;
  gap: 14px;
  font-size: 12px;
  color: #6b7280;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.job-type {
  margin-left: 12px;
}

.badge {
  padding: 6px 12px;
  border-radius: 14px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

/* Abierto */
.badge.abierto,
.badge.aprobado_admin {
  background: #dcfce7;
  color: #15803d;
}

/* Cerrado */
.badge.cerrado,
.badge.no_adjudicado,
.badge.rechazado_admin,
.badge.vencido {
  background: #fbcfe8;
  color: #9d174d;
}

/* En evaluación (amarillo) */
.badge.en_evaluación,
.badge.en-evaluación,
.badge.en_postulacion,
.badge.en_proceso,
.badge.observado {
  background: #fef9c3;
  color: #a16207;
}

/* Activo (azul) */
.badge.activo {
  background: #dbeafe;
  color: #1d4ed8;
}

/* Adjudicados (verde fuerte) */
.badge.adjudicado {
  background: #bbf7d0;
  color: #166534;
}
.job-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.job-actions button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

/* Ver detalle */
.job-actions button:first-child {
  background: transparent;
  border: 1px dashed #d1d5db;
  color: #374151;
}

.job-actions button:first-child:hover {
  background: #f9fafb;
}

/* Descargar TDR */
.job-actions .action-btn {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #374151;
}

.job-actions .action-btn:hover {
  background: #f3f4f6;
}

/* Postular */
.job-actions .action-btn.primary {
  background: #2563eb;
  color: #ffffff;
  border: none;
  font-weight: 600;
}

.job-actions .action-btn.primary:hover {
  background: #1d4ed8;
}
.job-detail {
  margin-top: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.job-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.job-detalle {
  font-size: 12px;
  color: #9ca3af;
  margin-top: -2px;
}

.btn-detalle {
  color: #4b5563 !important;
  background: #f3f4f6 !important;
}

.btn-detalle:hover {
  background: #f3f4f6 !important;
}

/* Descargar TDR – gris azulado */
.btn-tdr {
  border-color: #cbd5e1 !important;
  color: #475569 !important;
  background: #f8fafc !important;
}

.btn-tdr:hover {
  background: #f1f5f9 !important;
}

/* Postular – azul mate */
.btn-postular {
  background: #3b82f6 !important;
  color: #ffffff !important;
}

.btn-postular:hover {
  background: #2563eb !important;
}

.modal-card {
  border-radius: 14px;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-content {
  padding: 24px;
  font-size: 13px;
  color: #374151;
  line-height: 1.7;
}

.modal-content p {
  margin-bottom: 8px;
}

.modal-actions {
  border-top: 1px solid #e5e7eb;
}

.detalle-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 10px;
}

.detalle-section h4 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}

.detalle-item {
  display: grid;
  grid-template-columns: 60px 1fr 2fr;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px dashed #e5e7eb;
}

.detalle-cantidad {
  font-weight: 600;
  color: #2563eb;
}

.detalle-servicio {
  font-weight: 500;
  color: #374151;
}

.detalle-texto {
  color: #6b7280;
}

.detalle-empty {
  font-size: 13px;
  color: #9ca3af;
}

.modal-actions {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
}

.btn-cerrar {
  background: #e5e7eb !important;
  color: #374151 !important;
  font-weight: 500;
}

.btn-cerrar:hover {
  background: #d1d5db !important;
}
/* Modal base */
.modal-overlay-postular {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content-postular {
  background: white;
  padding: 26px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
}

/* Confirmación */
.icon-check {
  width: 56px;
  height: 56px;
}

.modal-title-postular {
  color: #2563eb;
  margin: 14px 0;
}
/* Botón aceptar */
.btn-accept {
  background: #2563eb;
  color: white;
  padding: 10px 28px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}
.modal-card-pro {
  border-radius: 14px;
}

/* Header */
.modal-header-pro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title-pro {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.modal-subtitle-pro {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

/* Body */
.modal-body-pro {
  padding: 24px;
  font-size: 13px;
  color: #374151;
}

/* Sections */
.section-pro {
  background: #f9fafb;
  padding: 16px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.section-title-pro {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 14px;
  color: #111827;
}

/* Detalle items */
.detalle-item-pro {
  display: flex;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px dashed #e5e7eb;
}

.cantidad-pro {
  min-width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e0edff;
  color: #2563eb;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detalle-info-pro .servicio-pro {
  font-weight: 600;
  margin: 0;
}

.detalle-info-pro .detalle-pro {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.empty-pro {
  font-size: 13px;
  color: #9ca3af;
}

/* Info grid */
.info-grid-pro {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  padding: 20px;
  margin-top: 20px;

  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.info-item-pro {
  background: #ffffff;
  padding: 14px 16px;
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  text-align: justify;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-item-pro label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  margin-bottom: 6px;
  text-align: left;
}

.info-item-pro p {
  margin: 0;
  font-size: 13px;
  color: #1f2937;
  line-height: 1.6;
}

@media (max-width: 640px) {
  .info-grid-pro {
    grid-template-columns: 1fr;
  }
}

.email-pro {
  color: #2563eb;
}

/* Footer */
.modal-footer-pro {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
}

.btn-cerrar-pro {
  background: #e5e7eb !important;
  color: #374151 !important;
  font-weight: 600;
}
.modal-header-color {
  background: linear-gradient(135deg, #2563eb, #1e40af);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.modal-title-color {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.empresa-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
}

/* Botón cerrar */
.btn-close-modal {
  background: rgba(255, 255, 255, 0.15);
  transition: background 0.2s ease;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
}
/* Header sin Vuetify */
.modal-header-color {
  background: linear-gradient(135deg, #2563eb, #1e40af);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.modal-title-color {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.empresa-badge {
  margin-top: 4px;
  display: inline-block;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 12px;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.35);
}
.modal-actions-inline {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 20px;
}

.btn-cancel {
  background: #e5e7eb;
  color: #374151;
  padding: 10px 22px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.btn-cancel:hover {
  background: #d1d5db;
}

.instrucciones-box {
  margin: 16px 0;
  padding: 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  font-size: 13px;
}

.correo-destino {
  font-weight: 700;
  color: #15803d;
  margin: 6px 0;
}

.nota {
  font-size: 12px;
  color: #6b7280;
}
.requerimiento-box {
  margin: 12px auto 18px;
  padding: 10px 14px;
  width: 100%;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;

  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.5;

  /* 👇 CLAVES */
  word-break: break-word;
  overflow-wrap: anywhere;

  /* ❌ NO scroll */
  overflow: hidden;
}
.req-nombre {
  max-width: 100%;
  padding: 0 12px;
  margin: 8px auto 0;

  font-size: 14px;
  line-height: 1.5;
  color: #4b5563;

  text-align: center;

  /* 🔑 magia */
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;

  /* opcional: limitar altura sin mostrar scroll */
  max-height: 4.5em;        /* ~3 líneas */
  overflow: hidden;
}
.meta-fecha-fin {
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 600;
  background: #f3f4f6;
}

/* 🔥 Vence pronto */
.meta-fecha-fin.urgente {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.alerta-archivo {
    background-color: #fff3cd;
    border: 1px solid #ffe69c;
    color: #664d03;
    padding: 12px 16px;
    border-radius: 8px;
    margin: 15px 0;
    text-align: justify;
}

.contenedor-boton-archivo {
    display: flex;
    justify-content: center;
    margin-top: 12px;
}

.contenedor-boton-archivo button {
    padding: 7px 18px;
    border: none;
    border-radius: 5px;
    background-color: #0d6efd;
    color: white;
    cursor: pointer;
}

.contenedor-boton-archivo button:hover {
    background-color: #0b5ed7;
}
.texto-negrita {
    font-weight: 800 !important;
}
.icono-alerta {
    font-size: 28px;
    line-height: 1;
    flex-shrink: 0;
}
.icono-clip {
    font-size: 20px;
    line-height: 1;
}
</style>
